/*
  Koral Boutique - respaldo de visibilidad del visor.

  El visor se muestra con una transicion de opacidad. Hay navegadores con el
  renderizador degradado donde las transiciones CSS no progresan y el visor se
  queda en opacity:0 aunque ya tenga la clase is-open.

  Este respaldo observa la clase y fija la opacidad por estilo en linea, que no
  depende de que la transicion llegue a correr.
*/
(function () {
  if (window.__koralLbFix) return;
  window.__koralLbFix = true;

  function sync(lb) {
    if (lb.classList.contains('is-open')) {
      lb.style.opacity = '1';
      lb.style.display = 'flex';
    } else {
      lb.style.opacity = '0';
    }
  }

  function attach(lb) {
    if (lb.dataset.koralLbFix) return;
    lb.dataset.koralLbFix = '1';
    sync(lb);
    new MutationObserver(function () { sync(lb); })
      .observe(lb, { attributes: true, attributeFilter: ['class'] });
  }

  function scan() {
    var lb = document.querySelector('.koral-lb');
    if (lb) attach(lb);
  }

  if ('MutationObserver' in window) {
    new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
})();
